import { Card, Grid, Table, TableBody, TableContainer } from "@mui/material";
import Container from "@mui/material/Container";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";
import { API_URLS, ResDataType } from "src/api/apiUrls";
import useApiServices from "src/api/useApiServices";
import AppLoadingAndErrorWrapper from "src/components/common/AppLoadingAndErrorWrapper";
import Scrollbar from "src/components/scrollbar";
import { useSettingsContext } from "src/components/settings";
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable
} from "src/components/table";
import SMLinksTableRow from "src/sections/pages/social-media-links/SMLinksTableRow";

const TABLE_HEAD = [
  { id: "1", label: "Links" },
  { id: "2", label: "Value" },
  { id: "3", label: "Last updated" },
  { id: "4", label: "Actions" },
];

export default function SocialMediaLinks () {
  const { programId } = useParams();
  const settings = useSettingsContext();
  const table = useTable({ defaultRowsPerPage: 10 });
  const { useGetListApi, useDeleteApi } = useApiServices();

  const { data, isLoading, error, refetch, isRefetching } = useGetListApi<
    ResDataType["socialMediaLinks"]
  >({
    url: API_URLS.SM_LINKS_SETTINGS,
    parameters: {
      page: table.page,
      pageSize: table.rowsPerPage,
      programId,
    },
  });

  return (
    <>
      <Helmet>
        <title>Social media links</title>
      </Helmet>
      <Container maxWidth={settings.themeStretch ? false : "xl"}>
        <AppLoadingAndErrorWrapper
          isLoading={isLoading || isRefetching}
          errorMessage={error}
        >
          <Grid container spacing={4} my={1}>
            <Grid item xs={12}>
              <Card>
                <TableContainer>
                  <Scrollbar>
                    <Table>
                      <TableHeadCustom headLabel={TABLE_HEAD} />
                      <TableBody>
                        {isLoading ? (
                          [...Array(table.rowsPerPage)].map((i, index) => (
                            <TableSkeleton key={index} sx={{ height: 80 }} />
                          ))
                        ) : (
                          <>
                            {data!?.items?.map(row => (
                              <SMLinksTableRow
                                key={row.id}
                                row={row}
                              />
                            ))}
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </Scrollbar>
                </TableContainer>
                {data && (
                  <TablePaginationCustom
                    count={data?.totalItems}
                    page={data.currentPage ? +data.currentPage - 1 : 1}
                    rowsPerPage={table.rowsPerPage}
                    onPageChange={table?.onChangePage}
                    onRowsPerPageChange={table?.onChangeRowsPerPage}
                  />
                )}
              </Card>
            </Grid>
          </Grid>
        </AppLoadingAndErrorWrapper>
      </Container>
    </>
  );
}
